/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  Pagination,
  Tooltip,
  Modal,
} from "react-bootstrap";
import {
  GetSubscription,
  Deleteb2b,
  getb2b,
  searchB2B,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";

import Switch from "react-bootstrap-switch";

import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";

class b2blist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      b2bdetail: [],
      category: [],
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      page: "",
      loading: false,
      company_name: "",
      discount: "",
      delivery_value: "",
      note: "",
      alert: null,
      _notificationSystem: null,
      useraccess: "",
      noRecordFound: false,
      userDetailsPopUp: false,
      useContactList: [],
    };
    this.selectedb2b = this.selectedb2b.bind(this);
    this.deleteb2b = this.deleteb2b.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.openContactPop = this.openContactPop.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selectedb2b(cus) {
    localStorage.setItem("b2bid", JSON.stringify(cus));

    this.props.history.push("/admin/edit_b2b");
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));

    const obj = token.token;
    // GetSubscription(obj)
    // .then((response) => {
    //     // console.log(response.data);
    //     this.setState({
    //         subscription_detail : response.data.data
    //     })
    // })
    this.searchData();
    this.setState({
      useraccess: token.role,
    });
  }
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    this.searchdata();
  };

  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  resetSearch(e) {
    this.setState({
      company_name: "",
      discount: "",
      delivery_value: "",
      note: "",
    });
    this.searchData();
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({ noRecordFound: false });

    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.medicationcategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      searchB2B(
        this.state.company_name,
        this.state.discount,
        this.state.delivery_value,
        this.state.note,
        this.state.page,
        obj
      )
        .then((response1) => {
          var data = response1.data;

          // console.log(data.next_page_url);
          // console.log(data,data.last_page);
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("?page=") + 1
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("?page=") + 1
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }

          this.setState({ paginationData: $no_pages });

          this.setState({
            loading: false,
            b2bdetail: data.data,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    });
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteb2b(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Company detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  deleteb2b(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    // alert(id);
    // console.log(id);
    Deleteb2b(id, obj)
      .then(() => {
        // alert('category deleted');
        // window.location.href="#/admin/medication-category";
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  addB2B() {
    this.props.history.push("/admin/addb2b");
  }

  openContactPop = (contact) => {
    this.setState({ userDetailsPopUp: true, useContactList: contact });
  };

  closeusertrasactionmodal() {
    this.setState({ userDetailsPopUp: false, useContactList: [] });
  }

  render() {
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const b2bdetail = this.state.b2bdetail;
    const category = this.state.category;
    // console.log(medication_detail);
    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Card
              content={
                <React.Fragment>
                  <Row>
                    <div className="col-b2b">
                      {/* <Jumbotron className="col-b2b" 
                   // style={{marginLeft:"1%", background-color="#000000",marginRight:"1%" ,position: "relative",padding:"0 !important",marginTop:"40px !important"}} >
                   > */}
                      <Row>
                        <Col md={12} sm={12} lg={12} xs={12}>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <FormControl
                              className="btn-fill btn-size"
                              name="company_name"
                              value={this.state.company_name || ""}
                              placeholder="Company Name"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <FormControl
                              className="btn-fill btn-size"
                              name="discount"
                              value={this.state.discount || ""}
                              placeholder="Discount"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <FormControl
                              className="btn-fill btn-size"
                              name="delivery_value"
                              value={this.state.delivery_value || ""}
                              placeholder="Delivery Value"
                              onChange={this.onChange}
                              type="text"
                            />
                          </Col>

                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <Button
                              bsStyle="info"
                              className="btn-b2b-b2c-fill btn-size"
                              style={{
                                color: "#ffffff",
                                position: "relative",
                                top: "5px",
                              }}
                              fill
                              onClick={this.searchdata.bind(this)}
                            >
                              Filter
                            </Button>
                            &nbsp;&nbsp;
                          </Col>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <Button
                              bsStyle="info"
                              className="btn-b2b-b2c-fill btn-size"
                              style={{
                                color: "#ffffff",
                                position: "relative",
                                top: "5px",
                              }}
                              fill
                              onClick={this.resetSearch.bind(this)}
                            >
                              Reset
                            </Button>
                          </Col>
                          <Col md={2} sm={2} lg={2} xs={2} className="fl_mb_1">
                            <Button
                              className="btn-b2b-b2c-fill btn-size"
                              style={{
                                color: "#ffffff",
                                position: "relative",
                                top: "5px",
                              }}
                              bsStyle="info"
                              fill
                              onClick={this.addB2B.bind(this)}
                            >
                              Add B2B
                              <i className="fa fa-plus"></i>
                            </Button>
                          </Col>
                        </Col>
                      </Row>
                      {/* </Jumbotron> */}

                      {/* <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_from" value={this.state.delivery_distance_from ||''} placeholder="Delivery Distance From" onChange={this.onChange} type="text" />
                  </Col> 
                 <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_to" value={this.state.delivery_distance_to ||''} placeholder="Delivery Distance To" onChange={this.onChange} type="text" />
                  </Col> */}
                      <Col md={12} sm={12} lg={12} xs={12}>
                        <br />
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Company Name</th>
                              <th>Organization Type</th>
                              <th> Discount</th>
                              <th>Delivery Value</th>
                              <th>Note</th>
                              <th>Contact Person</th>
                              <th className="text-right">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loading ? (
                              <tr>
                                <td colspan="10">
                                  <LoadingSpinner />
                                </td>
                              </tr>
                            ) : this.state.noRecordFound ? (
                              <tr>
                                <td colspan="10">
                                  <center>No record found</center>
                                </td>
                              </tr>
                            ) : (
                              <React.Fragment>
                                {b2bdetail.map((detail) => (
                                  <tr style={{ textAlign: "left" }}>
                                    <td key={detail.id}>
                                      {detail.company_name}
                                    </td>
                                    <td>
                                      {detail.organization_type === null ? (
                                        "-"
                                      ) : detail.organization_type === 1 ? (
                                        <p className="btn btn-fill fl_text_purple">
                                          Parent
                                        </p>
                                      ) : (
                                        <p className="btn btn-fill fl_text_green">
                                          Child
                                        </p>
                                      )}
                                    </td>
                                    <td>{detail.discount}</td>
                                    <td>{detail.delivery_value}</td>
                                    <td>{detail.note}</td>
                                    <td>
                                      <td>
                                        <Button
                                          onClick={this.openContactPop.bind(
                                            this,
                                            detail.contact
                                          )}
                                        >
                                          <i
                                            style={{ fontSize: "16px" }}
                                            className="fa fa-user"
                                          ></i>
                                        </Button>
                                      </td>
                                    </td>
                                    <td className="td-actions text-right">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selectedb2b.bind(
                                            this,
                                            detail.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <Link to="/admin/edit_b2b">
                                            <i className="fa fa-edit" />
                                          </Link>
                                        </Button>
                                      </OverlayTrigger>
                                      {this.state.useraccess == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              detail.id
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            )}
                          </tbody>
                        </Table>
                        {this.state.loading ? (
                          ""
                        ) : this.state.noRecordFound ? (
                          ""
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <Pagination>
                              <Pagination.First
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.prevpage
                                )}
                                disabled={
                                  this.state.prevdisabled === 1 ? true : false
                                }
                              />
                              {this.state.paginationData.map((url) => (
                                <Pagination.Item
                                  active={
                                    this.state.currentPage == c ? true : false
                                  }
                                  onClick={this.paginationinfo.bind(this, url)}
                                >
                                  {c++}
                                </Pagination.Item>
                              ))}
                              <Pagination.Last
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.nextpage
                                )}
                                disabled={
                                  this.state.nextdisabled === 1 ? true : false
                                }
                              />
                            </Pagination>
                          </div>
                        )}
                      </Col>
                    </div>
                  </Row>
                </React.Fragment>
              }
            />
          </Row>
        </Grid>

        <Modal
          className=""
          bsSize="lg"
          show={this.state.userDetailsPopUp}
          aria-labelledby="example-modal-sizes-title-lg"
          onHide={() => this.setState({ userDetailsPopUp: false })}
        >
          <Modal.Header>
            <Modal.Title>Contact Person Detials</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>User Type</th>
                </tr>
              </thead>
              <tbody>
                {this.state.useContactList.length == 0 ? (
                  <td colspan="4" style={{ textAlign: "center" }}>
                    <h5>No Data Found</h5>{" "}
                  </td>
                ) : (
                  this.state.useContactList.map((u) => (
                    <tr>
                      <td>{u.name}</td>
                      <td>{u.email}</td>
                      <td>{u.mobile_no}</td>
                      <td>{u.user_type}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="danger"
              fill
              onClick={this.closeusertrasactionmodal.bind(this)}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default b2blist;
